import { DamageAction, DamagePart } from '@/types';

export const getActionParts = (
  actions?: DamageAction[],
  actionId?: number,
): DamagePart[] | undefined =>
  actions?.find((action) => action.id === actionId)?.parts;
